import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=7965b9d4"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7965b9d4')) {
      api.createRecord('7965b9d4', component.options)
    } else {
      api.reload('7965b9d4', component.options)
    }
    module.hot.accept("./Cart.vue?vue&type=template&id=7965b9d4", function () {
      api.rerender('7965b9d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Cart.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Cart.vue
// module id = 120
// module chunks = 0